import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CasesSelectors, SPLibraryService } from '@store';

@Component({
    selector: 'app-skilleblade-modal',
    template: `
        <app-skilleblade-modal-ui
            [splibrary]="splibrary$ | async"
            [cases]="cases$ | async"
        ></app-skilleblade-modal-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkillebladeModalContainer {

    splibrary$ = this.splibraryService.getSPLibrary();
    cases$ = this.casesSelector.clientCases$;

    constructor(
        private splibraryService: SPLibraryService,
        private casesSelector: CasesSelectors
    ) { }

}
